export const categoryOptions = [
  { label: "Grocery & Frozen", value: "grocery&Frozen" },
  { label: "Fresh Vegetable ", value: "freshVegetable" },
  { label: "Fresh Fruits ", value: "freshFruits" },
  { label: "Fruit Juices ", value: "fruitJuices" },
  { label: "Salads ", value: "salads" },
  { label: "Fresh Meat ", value: "freshMeat" },
  { label: "Butter & Egg ", value: "butter&Egg" },
  { label: "Milk Cream", value: "milkCream" },
  { label: "Oil & Vinegars", value: "oil&Vinegars" },
  { label: "Bread & Bakery", value: "bread&Bakery" },
  { label: "Snacks Item", value: "snacksItem" },
  { label: "Fish", value: "fish" },
];

export const stockStatusOptions = [
  { label: "In Stock", value: "in stock" },
  { label: "out of stock", value: "Out of Stock" },
];

export const dimensionsOptions = [
  { label: "N/A", value: "N/A" },
  { label: "Yes", value: "Yes" },
];
